import { XSnackbar } from '@adornis/chemistry/elements/components/x-snackbar.js';
/**
 * @customElement cr-snackbar
 */
export class ChromiumSnackbar extends XSnackbar {
  public static override async show(msg: string, duration: number = 6000, minDuration: number = 1000) {
    super.show(msg, duration, minDuration);
  }
}
